export default __webpack_public_path__ + "static/media/home-main-article-image.67df6f45.webp";